export default __webpack_public_path__ + "static/media/logo-mobile2.a05cee3b.png";